import React, { FC } from "react";
import { InlineFormProps } from "./InlineForm.types";
import styles from "./InlineForm.module.scss";
import { Typography } from "../index";

const InlineForm: FC<InlineFormProps> = ({
  placeholder,
  submitText,
  onSubmit,
}) => {
  const handleOnSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <form
      className={styles.InlineForm}
      data-testid="InlineForm"
      onSubmit={handleOnSubmit}
    >
      <input
        placeholder={placeholder}
        type={"email"}
        name={"email"}
        required={true}
      />
      <button type={"submit"}>
        <Typography variant={"p"} token={200} weight={"medium"}>
          {submitText}
        </Typography>
      </button>
    </form>
  );
};

export default InlineForm;
